import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';

export const LinkFieldsSchema = z.object({
  text: z.string(),
  url: z.string()
});

export const LinkDocumentSchema = SanityDocumentSchema.extend({
  text: z.string(),
  url: z.string()
});

export type LinkFields = z.infer<typeof LinkFieldsSchema>;
export type LinkDocument = z.infer<typeof LinkDocumentSchema>;
